const emailRegexp = /\S+@\S+\.\S+/;
const stringRegexp = /\S+/;
const fullNameRegexp = /^(([A-Za-z]+[-']?)*([A-Za-z]+)?\s)+([A-Za-z]+[-']?)*([A-Za-z]+)?$/;
const passwordRegexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./\\:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,-./\\:;<=>?@[\]^_`{|}~]{8,}$/;

export const validationRules = {
  username: emailRegexp,
  email: emailRegexp,
  fullName: fullNameRegexp,
  name: fullNameRegexp,
  password: passwordRegexp,
  exist: stringRegexp
};

export function validate(value, rule) {
  const result = rule.test(value);
  return result;
}
